import JSONAPISerializer from 'json-api-serializer'

export default class SerializerUnauthenticated {
  constructor() {
    const serializer = new JSONAPISerializer()

    serializer.register('engineer-check-in-access-tokens', {
      relationships: {
        contractor: {
          type: 'contractors',
        },
        user: {
          type: 'users',
        },
      },
    })

    serializer.register(`contractors`)

    serializer.register(`users`)

    serializer.register(`user-pending-verification-methods`)

    return serializer
  }
}
